export default __webpack_public_path__ + "static/media/recognition.f8ac71d4.svg";